module.exports = __webpack_public_path__ + "5d27530f546266cff35588c374e49f19.svg";